export interface TypedStorage extends Omit<Storage, 'length'> {
  get<T>(key: string): T | null;
  get<T>(key: string, defaultVal: T): T;

  set<T>(key: string, value: T): void;
}

const storage = (st: Storage): TypedStorage => {
  function get<T>(key: string, defaultVal: T | null = null): T | null {
    const str = st.getItem(key);
    if (str === null) {
      return defaultVal;
    }

    const val = JSON.parse(str) as T;
    return val;
  }

  function set<T>(key: string, value: T): void {
    const str = JSON.stringify(value);
    st.setItem(key, str);
  }

  const fwFunc =
    <N extends keyof Storage>(name: N): Storage[N] =>
    (...args: any[]) =>
      st[name](...args);

  const origStore = Object.fromEntries(
    ['clear', 'removeItem', 'setItem', 'getItem', 'key'].map(
      (key: keyof Storage) => [key, fwFunc(key)] as const,
    ),
  );

  return {
    ...origStore,
    get,
    set,
  };
};

export default storage;
